import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { capitalizeFirstLetter } from '@spotahome/ui-library/src/tenant/components/utils/stringUtils';

import { getPropertyTypeTranslation } from '../utils/seoCharts';

const sortFn = (a, b) => b.percentage - a.percentage;

const normalizeSections = data => {
  const normalizedData = data?.map(item => {
    return {
      ...item,
      label: capitalizeFirstLetter(
        getPropertyTypeTranslation(item.propertyType)
      )
    };
  });
  normalizedData.sort(sortFn);
  return normalizedData;
};

const UserInteractionStatisticsContext = createContext({
  userInteractionStatistics: []
});

export const UserInteractionStatisticsProvider = ({
  children,
  cityId,
  userInteractionStatistics: initialUserInteractionStatistics = []
}) => {
  const userInteractionStatistics = normalizeSections(
    initialUserInteractionStatistics
  );

  return (
    <UserInteractionStatisticsContext.Provider
      value={{
        cityId,
        userInteractionStatistics,
        propertyTypeWithMoreInteractions:
          userInteractionStatistics[0]?.label ?? '',
        secondPropertyTypeWithMoreInteractions:
          userInteractionStatistics[1]?.label ?? '',
        propertyTypeWithLessInteractions:
          userInteractionStatistics.at(-1)?.label ?? ''
      }}
    >
      {children}
    </UserInteractionStatisticsContext.Provider>
  );
};

UserInteractionStatisticsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  cityId: PropTypes.string.isRequired,
  userInteractionStatistics: PropTypes.arrayOf(
    PropTypes.shape({
      propertyType: PropTypes.string,
      percentage: PropTypes.string
    })
  )
};

export const useUserInteractionStatisticsContext = () =>
  useContext(UserInteractionStatisticsContext);

export default {
  UserInteractionStatisticsProvider,
  useUserInteractionStatisticsContext
};
